module.exports = __webpack_public_path__ + "img/bg64.f246b048.png";